const LEGACY_PREFIX = '/fleet-management/digital-vehicle-files';
const CURRENT_PREFIX = '/fleet-management/vehicles';

/**
 * Rewrites a legacy vehicle-list URL onto the current prefix, preserving the
 * child path (`/new`, `/:vehicleId`) and any search params. Prefixed with `-`
 * so the router's file-based generator skips it.
 */
export function redirectToVehicles(href: string) {
  return {
    href: href.replace(LEGACY_PREFIX, CURRENT_PREFIX),
    replace: true,
  };
}
